import { BorderColor, BorderTop, Padding } from '@mui/icons-material';
import { COLORS } from '../../../../../utils/colors';
import { display } from 'html2canvas/dist/types/css/property-descriptors/display';

export const useAIPromptCardStyles = () => {
  return {
    cardContainer: {
      border: `.125rem solid ${COLORS.LIGHT_GRAY}`,
      cursor: 'pointer',
      height: 'fit-content',
      minHeight: '6rem',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      paddingTop: 0,
      mx: '1rem',
      my: '0rem',
      mt: '1rem',
      mr: '1rem',
      borderRadius: '1rem',
      padding: '0 1rem',
    },
    iconTray: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
    },
    cardSelect: {
      border: `.125rem solid ${COLORS.PRIMARY}`,
      transition: 'background-color 0.3s ease',
      position: 'relative',
      pointer: 'default',
    },
    title: {
      textTransform: 'uppercase',
      fontWeight: 600,
      paddingBottom: '1rem',
      fontSize: '.8125rem',
      pb: 0,
    },
    model: {
      textTransform: 'uppercase',
      marginLeft: 'auto',
      marginRight: '1rem',
      minWidth: '4rem',
      paddingBottom: '1rem',
      opacity: 0,
    },
    description: {
      paddingBottom: '1rem',
      fontSize: '.8125rem',
    },
    buttonBox: {
      display: 'flex',
      alignItems: 'center',
      padding: '0',
      justifyContent: 'start',
      //borderTop: `.125rem solid ${COLORS.LIGHT_GRAY}`,
      borderTop: '.125rem solid #eee',
    },
    iconButton: {},
    trayButton: {
      cursor: 'pointer',
      marginRight: '1rem',
      borderRadius: '.25rem',
      padding: '.25rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '2rem',
      height: '2rem',
      color: '#888',
      border: `.1rem solid #d3d3d3`,
      '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' },
    },
    menuOpenIcon: {
      transform: 'rotate(90deg)',
    },
    viewButton: {
      height: 'auto',
    },
    textField: {
      width: '100%',
      height: 'fit-content',
    },
    enterMessage: {
      display: 'block',
      borderTop: `1px solid ${COLORS.LIGHT_GRAY}`,
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      bgcolor: COLORS.WHITE,
      px: '.75rem',
      '& .MuiInput-input': {
        height: '2.5rem',
        outline: 'none',
      },
      '& .MuiInput-root:before': {
        outline: 'none',
        border: 'none',
      },
    },
    cardOptionContainer: {
      display: 'block',
      alignItems: 'center',
      width: '100%',
      padding: '1rem',
      paddingBottom: '0rem',
      position: 'relative',
      zIndex: 1000,
    },
    cardDetail: {
      display: 'flex',
      width: '100%',

      justifyContent: 'flex-end',
      paddingBottom: '2rem',
    },
    closeButton: {
      width: '2.5rem',
      height: '2.5rem',
      borderRadius: '50%',
      '&:hover': {
        backgroundColor: '#FFE4B5',
      },
    },
    generateButton: {
      minWidth: '7rem',
      borderRadius: '2rem',
      padding: '0.5rem 1rem',
      '&:hover': {
        backgroundColor: COLORS.PRIMARY,
      },
    },
    loadingBox: {
      display: 'flex',
      justifyContent: 'center',
      padding: '0.5rem',
    },
    menuBox: {
      background: '#fff',
      borderRadius: '1rem',
      boxShadow: '0px .125rem .125rem rgba(0, 0, 0, 0.2)',
    },
    input: {
      '& .MuiInput-input': {
        //height: '10.5rem',
      },
    },
    promptInput: {
      '& .MuiInputBase-inputMultiline': {
        padding: '0.625rem',
        minHeight: '5rem',
        borderRadius: '1rem',
      },
      '& .MuiInputBase-root': {
        //borderRadius: '1rem',
        padding: '0',
      },
    },
    newSectionButton: {
      minWidth: '7rem',
      borderRadius: '1rem',
      padding: '0.25rem 1rem',
      backgroundColor: COLORS.WHITE,
      color: COLORS.PRIMARY,
      border: `1px solid ${COLORS.PRIMARY}`,
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: COLORS.PRIMARY,
        color: COLORS.WHITE,
        boxShadow: 'none',
      },
    },
    newSectionBox: {
      justifyContent: 'flex-end',
      padding: '1rem',
    },
    iconBox: {
      borderRadius: '.25rem',
      padding: '.25rem',
      width: '2rem',
      height: '2rem',
      color: '#888',
      marginLeft: '0.5rem',
    },
    cardContent: {
      mb: '1.5rem',
      borderRadius: '1rem',
      '& .MuiOutlinedInput-root': {
        cursor: 'pointer',
        '&:hover fieldset': {
          borderColor: 'rgba(0, 0, 0, 0.23)',
        },
        '&.Mui-focused fieldset': {
          borderColor: 'rgba(0, 0, 0, 0.23)',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(0, 0, 0, 0.23) !important',
          borderWidth: '1px !important',
        },
      },
      '& .MuiInputBase-input': {
        cursor: 'pointer',
        userSelect: 'none',
      },
      '& .MuiInputLabel-root': {
        '&.Mui-focused': {
          color: 'rgba(0, 0, 0, 0.6) !important',
        },
      },
    },
    editingTitle: {
      textTransform: 'uppercase',
      fontWeight: 600,
      paddingBottom: '1rem',
      fontSize: '.8125rem',
      border: '1px solid #ccc',
      background: 'transparent',
      display: 'flex',
      alignItems: 'center',
      padding: '0.5rem',
      '&:focus-visible': {
        border: '1px solid #ccc',
        background: 'transparent',
        outline: 'none',
      },
    },
  };
};
